import script from "./ReportView.legacySurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportView.legacySurvey.vue?vue&type=script&setup=true&lang=js"

import "./ReportView.legacySurvey.vue?vue&type=style&index=0&id=34f0b356&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f0b356"]])

export default __exports__